import columns from 'utils/columns/wiseBoxDevices';
import { initialStateFactory, reducerFactory, sagasFactory } from 'utils/factories';
import actionsFactory from 'utils/factories/actions';
import { WISE_BOX_DEVICE } from './actionTypes';

// actions
const actions = actionsFactory(WISE_BOX_DEVICE);

export { actions };

// reducer
const initialState = initialStateFactory(columns);
const reducer = reducerFactory(WISE_BOX_DEVICE);

export default (state = initialState, action) => reducer(state, action);

// sagas
const sagas = sagasFactory(WISE_BOX_DEVICE, '/devices/wise_boxes');

export { sagas };
